import { apiRequestType } from "@/api/interfaces/IApi";
import {
  templatesData,
  templatesQuery
} from "@/api/interfaces/templates/common";
import {
  ITemplatesDataResponse,
  ITemplatesTypesDataResponse
} from "@/api/interfaces/templates/ITemplatesResponseData";
import {
  ITemplatesData,
  ITypeTemplateData
} from "@/store/interfaces/templates/ITemplateData";
import { queryObjectToUrlString } from "@/utills/queryObjectToUrlString";

export const templatesService = {
  async fetchTemplatesData(
    request: apiRequestType,
    query: templatesQuery
  ): Promise<ITemplatesDataResponse> {
    const queryString: string = queryObjectToUrlString(query);

    const response = await request(
      `/templates/getAllTemplates?${queryString}`,
      "get"
    );
    const data: ITemplatesData = <ITemplatesData>response.data;

    return {
      ...response,
      data
    };
  },
  async fetchTemplatesTypeData(
    request: apiRequestType
  ): Promise<ITemplatesTypesDataResponse> {
    const response = await request(`/templates/types/all`, "get");
    const data: ITypeTemplateData = <ITypeTemplateData>response.data;

    return {
      ...response,
      data
    };
  },
  async addTemplate(request: apiRequestType, reqData: templatesData) {
    const response = await request(
      `/templates/createTemplate`,
      "post",
      reqData
    );
    const data: ITemplatesData = <ITemplatesData>response.data;

    return {
      ...response,
      data
    };
  },
  async updateTemplate(request: apiRequestType, reqData: templatesData) {
    const response = await request(
      `/templates/editTemplate/${reqData.id}`,
      "put",
      reqData
    );
    const data: ITemplatesData = <ITemplatesData>response.data;

    return {
      ...response,
      data
    };
  },
  async deleteTemplate(request: apiRequestType, id: number) {
    const response = await request(`/templates/deleteTemplate/${id}`, "delete");
    const data: ITemplatesData = <ITemplatesData>response.data;

    return {
      ...response,
      data
    };
  }
};
